import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import { LicenseRaw, LicenseModel } from "../models";
import { getLicenseForCurrentUser } from "../api";
import { setCurrentLicenseHandle } from "./mutations";

const factory = new FetchFactory<StateInterface, {}>();

export default {
  fetchCurrentLicense: factory.createSingleFetcher<
    {},
    LicenseRaw,
    LicenseModel
  >(
    true,
    setCurrentLicenseHandle,
    getLicenseForCurrentUser,
    (): LicenseModel => new LicenseModel()
  )
};
